<template>
	<div v-click-outside="close" class="select3" @keyup.up="moveUp" @keyup.down="moveDown" @keyup.enter="selectValue(null)">
		<!-- <span class="result" v-if="value">{{ value }}</span> -->
		<span v-if="selected" class="result">{{ selected[config.valueName] }}</span>
		<input class="input" type="text" @click="isOpened = !isOpened" v-model="filter">
		<a class="clear" href="#" @click.prevent="clearSelect(true)">×</a>
		<ul v-if="isOpened" class="list" @click="isOpened = false" ref="container"> 
			<li v-for="(row, index) in filteredData" :class="[activeIndex === index ? 'focus' : '']" :ref="'selected_' + index" @click="selectValue(index)">{{ row[config.valueName] }}</li>
			<li v-if="filteredData.length === 0" disabled>No available options</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			config: {
				type: Object,
				required: false
			},
			data: {
				type: Array,
				required: false
			},
			addNew: {
				type: Boolean,
				default: false
			},
			value: {
				required: false
			}
		},
		data() {
			return {
				filteredData: this.data,
				isOpened: false,
				activeIndex: 0,
				selected: false,

				filter: null
			}
		},
		created() {
			let vm = this;
			if (vm.value) {
				let val = null;
				if(vm.config.hasOwnProperty('originalValue') && vm.config.originalValue) {
					val = _.cloneDeep(vm.data.find(element => element[vm.config.keyName] === vm.value[vm.config.keyName]));
				} else {
					val = _.cloneDeep(vm.data.find(element => element[vm.config.keyName] === vm.value));
				}

				if (val) {
					vm.selected = val;
				} else {
					let newRow = {};
					newRow[vm.config.keyName] = val;
					newRow[vm.config.valueName] = val;
					vm.data.push(newRow);
					vm.selected = _.cloneDeep(newRow);
				}
			}

			vm.$watch('value', function () {
				if (vm.value === null) {
					vm.clearSelect(true);
				} else {
					if(vm.config.hasOwnProperty('originalValue') && vm.config.originalValue) {
						vm.selected = _.cloneDeep(vm.data.find(element => element[vm.config.keyName] === vm.value[vm.config.keyName]));
					} else {
						vm.selected = _.cloneDeep(vm.data.find(element => element[vm.config.keyName] === vm.value));
					}
				}
			});

			vm.$watch('filter', _.debounce(function () {
				vm.filterData();
			}, 500));
		},
		methods: {
			moveUp: function () {
				let vm = this;

				if (vm.activeIndex > 0) {
					vm.activeIndex--;
					vm.$refs.container.scrollTop = vm.activeIndex * this.$refs['selected_' + vm.activeIndex][0].scrollHeight;
				} else {
					vm.activeIndex = vm.filteredData.length - 1;
					vm.$refs.container.scrollTop = vm.$refs.container.scrollHeight;
				}
			},
			moveDown: function () {
				let vm = this;

				if (vm.activeIndex < vm.filteredData.length - 1) {
					vm.activeIndex++;
					vm.$refs.container.scrollTop = vm.activeIndex * this.$refs['selected_' + vm.activeIndex][0].scrollHeight;
				} else {
					vm.activeIndex = 0;
					vm.$refs.container.scrollTop = 0;
				}
			},
			close: function () {
				let vm = this;

				vm.isOpened = false;
				vm.filteredData = vm.data;
				vm.activeIndex = 0;
			},
			selectValue: function (value) {
				let vm = this;

				if (value !== null) {
					vm.selected = _.cloneDeep(vm.filteredData[value]);
					if(vm.config.hasOwnProperty('originalValue') && vm.config.originalValue) {
						vm.$emit('update:value', vm.selected);
					} else {
						vm.$emit('update:value', vm.selected[vm.config.keyName]);
					}
					vm.filter = null;
				} else {
					if (vm.filter) {
						if (vm.filteredData.length > 0) {
							vm.selected = _.cloneDeep(vm.filteredData[vm.activeIndex]);
							if(vm.config.hasOwnProperty('originalValue') && vm.config.originalValue) {
								vm.$emit('update:value', vm.selected);
							} else {
								vm.$emit('update:value', vm.selected[vm.config.keyName]);
							}
							vm.filter = null;
						} else {
							if (vm.addNew) {
								let newRow = {};
								newRow[vm.config.keyName] = vm.filter;
								newRow[vm.config.valueName] = vm.filter;
								vm.data.push(newRow);
								vm.$emit('update:value', vm.filter);
							}
						}
					}
				}

				vm.close();
			},
			clearSelect: function (emit) {
				let vm = this;

				vm.selected = null;
				vm.filter = null;
				if (emit) {
					vm.$emit('update:value', null);
				}

				vm.filteredData = vm.data;
			},
			filterData: function () {
				let vm = this;

				if (vm.filter) {
					let query = vm.filter.toLowerCase();
					vm.filteredData = vm.data.filter(element => element[vm.config.valueName] && element[vm.config.valueName].toLowerCase().indexOf(query) >= 0);
				} else {
					vm.filteredData = vm.data;
				}
			}
		}
	}
</script>

<style scoped>

</style>
